export default __webpack_public_path__ + "static/MichaelsPublicHearing-116c6615ca37da46bfd3ed3664550df3.jpg";